const Listing = () => import('../../components/Transaction/List')

export default {
    path: 'tbc-transactions',
    redirect: 'tbc-transactions',
    component: {
        template: '<router-view></router-view>',
    },
    name: 'tbc-transactions',
    meta: {'permissions': 'view-tbc-transactions'},
    children: [
        {
            path: '/',
            component: Listing,
        },
    ],
};
